import CategoryMenuImg from './category_menu.png';

export { CategoryMenuImg };
